<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc—title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/02_Chapter01"><span class="toc">1.</span> A Fairy in the Flat</a></h2>
<h2 class="toc"><a href="#/xhtml/03_Chapter02"><span class="toc">2.</span> A Pot of Tea</a></h2>
<h2 class="toc"><a href="#/xhtml/04_Chapter03"><span class="toc">3.</span> The Affair of The Pink Pearl</a></h2>
<h2 class="toc"><span href="#/xhtml/05_Chapter04" title="Link target outside of Sample"><span class="toc">4.</span> The Affair of The Pink Pearl (continued)</span></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter05" title="Link target outside of Sample"><span class="toc">5.</span> The Adventure of The Sinister Stranger</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter06" title="Link target outside of Sample"><span class="toc">6.</span> The Adventure of The Sinister Stranger (continued)</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter07" title="Link target outside of Sample"><span class="toc">7.</span> Finessing the King</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter08" title="Link target outside of Sample"><span class="toc">8.</span> The Gentleman Dressed in Newspaper</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter09" title="Link target outside of Sample"><span class="toc">9.</span> The Case of The Missing Lady</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter10" title="Link target outside of Sample"><span class="toc">10.</span> Blindman’s Buff</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter11" title="Link target outside of Sample"><span class="toc">11.</span> The Man in the Mist</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter12" title="Link target outside of Sample"><span class="toc">12.</span> The Man in the Mist (continued)</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter13" title="Link target outside of Sample"><span class="toc">13.</span> The Crackler</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter14" title="Link target outside of Sample"><span class="toc">14.</span> The Crackler (continued)</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter15" title="Link target outside of Sample"><span class="toc">15.</span> The Sunningdale Mystery</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter16" title="Link target outside of Sample"><span class="toc">16.</span> The Sunningdale Mystery (continued)</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter17" title="Link target outside of Sample"><span class="toc">17.</span> The House of Lurking Death</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter18" title="Link target outside of Sample"><span class="toc">18.</span> The House of Lurking Death (continued)</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter19" title="Link target outside of Sample"><span class="toc">19.</span> The Unbreakable Alibi</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter20" title="Link target outside of Sample"><span class="toc">20.</span> The Clergyman’s Daughter</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter21" title="Link target outside of Sample"><span class="toc">21.</span> The Red House</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Chapter22" title="Link target outside of Sample"><span class="toc">22.</span> The Ambassador’s Boots</span></h2>
<h2 class="toc"><span href="#/xhtml/24_Chapter23" title="Link target outside of Sample"><span class="toc">23.</span> The Man Who Was No. 16</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3851a80c